$ var data = component.getTemplateData(state, input);
$ var config = data.config;
$ var discrete = data.totalSlides >= 1;
$ var statusId = (discrete && "carousel-status-" + component.id) || (
   data.a11yStatusText || data.a11yHeadingText && component.getElId("carousel"));

<div ...data.htmlAttributes
    class=data.classes
    style=data.style
    aria-labelledby=statusId
    role="group"
    aria-roledescription="carousel">
   <div
        class=[
            "carousel__container",
            data.bothControlsDisabled &&
                "carousel__container--controls-disabled"
        ]
        onFocusin(data.autoplayInterval && "handleStartInteraction")
        onTouchstart(data.autoplayInterval && "handleStartInteraction")
        onMouseover(data.autoplayInterval && "handleStartInteraction")
        onFocusout(data.autoplayInterval && "handleEndInteraction")
        onMouseout(data.autoplayInterval && "handleEndInteraction")
        onTouchend(data.autoplayInterval && "handleEndInteraction")
        key="container"
        id:scoped="container">
        <if(data.a11yStatusText || data.a11yHeadingText)>
            <${discrete ? data.a11yStatusTag : data.a11yHeadingTag}
                id=statusId
                class="clipped"
                aria-live=(
                    discrete
                        ? data.autoplayInterval && !data.paused
                            ? "off"
                            : "polite"
                        : false
                )>
                <if(discrete)>
                    <span>${data.a11yStatusText}</span>
                </if>
                <else>
                    <span>${data.a11yHeadingText}</span>
                </else>
            </>
        </if>
        <button
            class=[
                "carousel__control",
                "carousel__control--prev"
            ]
            type="button"
            on-click(!data.prevControlDisabled && "handleMove", -1)
            aria-describedby=statusId
            aria-label=data.a11yPreviousText
            aria-disabled=(data.prevControlDisabled && "true")>
            <ebay-carousel-prev-icon/>
        </button>
        <div class=[
            "carousel__viewport",
            !data.itemsPerSlide &&
            !data.nextControlDisabled &&
            !data.autoplayInterval &&
                "carousel__viewport--mask"]>
            <ul
                class=["carousel__list", input.imageTreatment === "matte" && "carousel__list--image-treatment"]
                style=(
                    !config.nativeScrolling &&
                        data.offset && {
                            transform: "translate3d(" + data.offset * -1 + "px,0,0)",
                            transition: data.disableTransition ? "none" : undefined
                        }
                )
                key="list"
                id:scoped="list">
                <for|item| of=data.items>
                    <li
                        ...item.htmlAttributes
                        key=item.key
                        class=item.class
                        style=item.style
                        aria-hidden=(!item.fullyVisible && "true")
                        no-update-body-if(!!config.preserveItems)>
                        <${item.renderBody}/>
                    </li>
                </for>
            </ul>
        </div>
        <button
            class=[
                "carousel__control",
                "carousel__control--next"
            ]
            type="button"
            on-click(!data.nextControlDisabled && "handleMove", 1)
            aria-describedby=statusId
            aria-label=data.a11yNextText
            aria-disabled=(data.nextControlDisabled && "true")
            key="next"
            id:scoped="next">
            <ebay-carousel-next-icon/>
        </button>
        <if(data.autoplayInterval && !data.bothControlsDisabled)>
            <button
                class="carousel__playback"
                type="button"
                aria-label=(data.paused ? data.a11yPlayText : data.a11yPauseText)
                onClick("togglePlay")>
                <if (data.paused)>
                    <ebay-play-icon />
                </if>
                <else>
                    <ebay-pause-icon />
                </else>
            </button>
        </if>
    </div>
</div>
